import { render, staticRenderFns } from "./DashboardTasksPanel.vue?vue&type=template&id=63112030&scoped=true"
import script from "./DashboardTasksPanel.vue?vue&type=script&lang=js"
export * from "./DashboardTasksPanel.vue?vue&type=script&lang=js"
import style0 from "./DashboardTasksPanel.vue?vue&type=style&index=0&id=63112030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63112030",
  null
  
)

export default component.exports